<template>
    <div class="item vertical-center">
        <div class="width-all">
            <div>{{data.num | fixedLength}} {{unit}}</div>
            <div class="line" :class="color ? 'green' : 'orange'"></div>
            <div>{{data.title}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "dataTips",
        props: {
            data: {
                type: Object,
                default: {
                    num: 0,
                    title: ''
                }
            },
            color: {
                type: Boolean,
                default: true
            },
            unit: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style lang="less" scoped>
    .item {
        width: 50%;
        height: 100%;
        text-align: center;
        .line {
            width: 30%;
            height: 3px;
            margin: 12px auto;
            &.green {
                background: #32ebaa;
            }
            &.orange {
                background: #ffcc66;
            }
        }
        & > div {
            font-size: 16px;
            div:first-child{
                font-weight: bold;
                font-size: 18px;
            }
        }
    }
</style>